export default "__VITE_ASSET__BbEiQAi9__"